import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingSmall from "./HeadingSmall";
import PropTypes from "prop-types";
import Quote from "./Quote";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TwoColBox from "./TwoColBox";

function BrandPageSectionOne({
  heading,
  text,
  quote,
  quoteSource,
  quoteImage,
}) {
  return (
    <BoxWithGutter pt={[38, null, 100, null]} pb={[60, null, 150, null]}>
      <TwoColBox
        col1={<HeadingSmall>{heading}</HeadingSmall>}
        col2={<RichTextLarge>{text}</RichTextLarge>}
      />
      <Box mt={[60, null, 100, null]}>
        <Quote
          quote={quote}
          quoteSource={quoteSource}
          quoteImage={quoteImage}
        />
      </Box>
    </BoxWithGutter>
  );
}

export default BrandPageSectionOne;

BrandPageSectionOne.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  quoteSource: PropTypes.string.isRequired,
  quoteImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};
